import { render } from "./FormAddressView.vue?vue&type=template&id=ef67d460"
import script from "./FormAddressView.vue?vue&type=script&lang=js"
export * from "./FormAddressView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__